import router, { notFound } from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { getToken } from '@/utils/auth' // 验权

let count = 0 // 解决只添加首页存在死递归问题

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      
      next({ path: '/' })
      NProgress.done()
    } else {
      //获取跳转路径信息 发送vuex保存
      let obj = {
        title: to.meta.title,
        name: to.name,
        params: to.query
      }
      // let role = JSON.parse(localStorage.getItem('ROLE'))
      // let role = JSON.parse(store.getters.userInfo.role_info.role_info) || []
      let role = store.getters.userInfo.role_info.role_info ? JSON.parse(store.getters.userInfo.role_info.role_info) : []

      //分发当前路由信息
      store.dispatch('NodeHistory', JSON.stringify(obj))

      if(!store.state.promission.addRoutes.length && !count) {
        const isAdmin = store.getters.userInfo.id == 1 ? 'admin': role
        // const isAdmin = store.getters.userInfo.id == 1 ? role: role
        const accessRouter = await store.dispatch('generateRoutes', isAdmin)
        count++

        router.addRoutes(accessRouter)
        router.addRoutes(notFound)
        next({ ...to, replace: true })
      }else {
        next()
      }
      
      // if (store.getters.roles.length === 0) {
        
      //   next()
      // } else {
      //   next()
      // }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js